import { z } from 'zod';
// Gedeelde bouwstenen voor alle schema's (ONTWERP.md §4 conventies).
/** UUIDv7 als tekst. */
export const Id = z
    .string()
    .regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/, 'ongeldige id');
/** Instant (timestamptz) als ISO 8601 met offset, bv. `2026-09-23T10:00:00.000Z`. */
export const Instant = z.iso.datetime({ offset: true });
/** Wandkloktijd zonder zone (timestamp without time zone), bv. `2026-09-23T07:30:00`. */
export const LocalDateTime = z.iso.datetime({ local: true, offset: false });
/** Kalenderdatum `YYYY-MM-DD`. */
export const LocalDate = z.iso.date();
/** Tijd van de dag `HH:MM`. */
export const LocalTime = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'verwacht HH:MM');
/** IANA-zone; F1 kent alleen Europe/Amsterdam maar de kolom is generiek. */
export const TimeZone = z.string().min(1).max(64).default('Europe/Amsterdam');
/**
 * Talen van het bord (golf 3, 0033_talen): spiegel van LOCALES in packages/i18n/src/locales.ts
 * (domain hangt niet van i18n af; een contracttest in de webapp bewaakt dat ze gelijk zijn).
 * Arabisch zonder regio (ar-SA kiest in Intl de islamitische kalender).
 */
export const LocaleCode = z.enum(['nl-NL', 'en-GB', 'tr-TR', 'ar', 'de-DE', 'fr-FR']);
/** Taal van een huishouden: standaard Nederlands. Voor PATCH-invoer LocaleCode gebruiken. */
export const Locale = LocaleCode.default('nl-NL');
/** Cijfers: gewoon (latn) of Arabisch-Indisch (arab; alleen in het Arabisch te kiezen). */
export const Digits = z.enum(['latn', 'arab']);
/** E-mail wordt altijd lowercase opgeslagen (login_identity.email uniek, lowercase). */
export const Email = z.string().trim().toLowerCase().pipe(z.email().max(254));
/** Opake actor-referentie (ONTWERP.md §4): nooit namen, e-mails of IP's. */
export const Actor = z
    .object({
    identity_id: Id.optional(),
    device_id: Id.optional(),
    member_id: Id.optional(),
    elevation_id: Id.optional(),
})
    .strict();
/**
 * Optimistic concurrency (§4 conventies, §5.6): muteerbare aggregaten dragen `version`; de
 * client stuurt `if_version` mee en krijgt 409 met het huidige record bij een mismatch.
 */
export const Version = z.number().int().min(1).default(1);
/** Gemeenschappelijke kolommen van elke tenant-tabel. */
export const TenantRow = z.object({
    id: Id,
    household_id: Id,
    created_at: Instant,
    updated_at: Instant,
});
//# sourceMappingURL=primitives.js.map